import {
  colorCss,
  lineHeightCss,
  mobileColorCss,
  mobileLineHeightCss,
  mobileTextCss,
  textCss,
} from 'common/utils/styleUtilsNew'
import { CheckboxUiInterface } from 'src/shared/components/checkbox/checkbox-ui.schema'
import { StrictRequired } from 'src/shared/types/typescript-utils/strict-required'
import styled, { css } from 'styled-components'

export type CheckboxLabelUiProps = StrictRequired<
  Pick<
    CheckboxUiInterface,
    | 'fontSize'
    | 'mobileFontSize'
    | 'lineHeight'
    | 'mobileLineHeight'
    | 'fontFamily'
    | 'mobileFontFamily'
    | 'color'
    | 'mobileColor'
  >
>

const CheckboxLabelUi = styled.label<CheckboxLabelUiProps>`
  display: flex;
  align-items: baseline;
  flex-basis: 100%;
  ${textCss}
  ${colorCss}
  ${lineHeightCss}

  ${p => p.theme.phone} {
    ${mobileTextCss}
    ${mobileColorCss}
    ${mobileLineHeightCss}
  }

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${mobileTextCss}
      ${mobileColorCss}
      ${mobileLineHeightCss}
    `}
`

export default CheckboxLabelUi
